module.exports = __webpack_public_path__ + "static/img/img_register.1f3fea32.png";